import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { icon } from "leaflet";
import MapIcon from "../../assets/images/svg/map.svg";
import "leaflet/dist/leaflet.css";

const Map = () => {
  const position = [21.17472, 72.83638];

  return (
    <>
      <MapContainer
        center={position}
        zoom={14}
        scrollWheelZoom={false}
        style={{ height: "500px" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker
          icon={icon({ iconUrl: MapIcon, iconSize: [38, 95] })}
          position={position}
        >
          <Popup>
            <b>Jay Veer Jyotish</b>
            <p>
              131, Nathubhai Tower, Opposite of Maruti suzuki showroom, Udhna
              main road, Surat, Gujarat, India-394210
            </p>
          </Popup>
        </Marker>
      </MapContainer>
    </>
  );
};

export default Map;
